import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "@/App";
import { ErrorBoundary, Modal } from "@/common";
import "@lifi/widget";
import "@/assets/css/archivo.css";
import "@/index.css";
import { Toaster, toast } from "sonner"; // ✅ import toast
import "@/i18next";
import { registerSW } from "virtual:pwa-register"; // ✅ import SW register

const { VITE_STATUS } = import.meta.env;

// ✅ Register Service Worker and show toast prompt
const updateSW = registerSW({
  onNeedRefresh() {
    toast("🚀 New version available", {
      description: "Click to update",
      action: {
        label: "Reload",
        onClick: () => updateSW(true),
      },
      duration: 0, // stays until clicked
    });
  },
  onOfflineReady() {
    console.log("App is ready for offline use.");
  },
});

createRoot(document.getElementById("root")).render(
  <StrictMode>
      <ErrorBoundary>
     <Toaster position="bottom-right" />
    <App />
    <Modal />
      </ErrorBoundary>
  </StrictMode>
);
